import { connectorsForWallets } from '@rainbow-me/rainbowkit';
import {
  metaMaskWallet,
  coinbaseWallet,
  rainbowWallet,
  walletConnectWallet,
  trustWallet,
  phantomWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { createConfig, http } from 'wagmi';
import { defineChain } from 'viem';
import { createBackendProxyTransport } from './customTransport';

const PROJECT_ID = import.meta.env.VITE_WALLETCONNECT_PROJECT_ID || '47f7f041891685e13def038cb657c6be';

const EMBERX_ICON = 'https://copper-causal-dove-26.mypinata.cloud/ipfs/bafybeiardzfjvppccwjmmnbea3tna4exjkl5yqiuejank43hqvzvimc4ou';

// Get Flare RPC URL from environment variable or use default
const FLARE_RPC_URL = import.meta.env.VITE_FLARE_RPC || 'https://flare-api.flare.network/ext/C/rpc';

// Define Flare Mainnet
export const flare = defineChain({
  id: 14,
  name: 'Flare',
  nativeCurrency: {
    decimals: 18,
    name: 'Flare',
    symbol: 'FLR',
  },
  rpcUrls: {
    // Note: Actual RPC calls go through backend proxy (see transports config below)
    // These URLs are used for chain metadata only
    default: { http: [FLARE_RPC_URL] },
    public: { http: [FLARE_RPC_URL] },
  },
  blockExplorers: {
    default: { name: 'Flare Explorer', url: 'https://flare-explorer.flare.network' },
  },
  iconUrl: EMBERX_ICON,
  testnet: false,
});

// Define Coston2 Testnet
export const coston2 = defineChain({
  id: 114,
  name: 'Coston2 Testnet',
  nativeCurrency: {
    decimals: 18,
    name: 'Coston2 Flare',
    symbol: 'C2FLR',
  },
  rpcUrls: {
    default: { http: ['https://coston2-api.flare.network/ext/C/rpc'] },
    public: { http: ['https://coston2-api.flare.network/ext/C/rpc'] },
  },
  blockExplorers: {
    default: { name: 'Coston2 Explorer', url: 'https://coston2-explorer.flare.network' },
  },
  iconUrl: EMBERX_ICON,
  testnet: true,
});

// ── EVM wallets for connecting to Flare ──────────────────────────────────────
// Xaman is intentionally excluded here — it is used on the XRPL side of the
// bridge (via the XUMM payload API), not as an EVM wallet connector.
const connectors = connectorsForWallets(
  [
    {
      groupName: 'Popular',
      wallets: [metaMaskWallet, coinbaseWallet, trustWallet, phantomWallet],
    },
    {
      groupName: 'Other',
      wallets: [rainbowWallet, walletConnectWallet],
    },
  ],
  { appName: 'EmberX', projectId: PROJECT_ID },
);

export const config = createConfig({
  chains: [flare, coston2],
  connectors,
  transports: {
    // Use backend proxy for authenticated RPC calls (adds API key header)
    [flare.id]: createBackendProxyTransport(),
    [coston2.id]: http('https://coston2-api.flare.network/ext/C/rpc'),
  },
  ssr: false,
});
